module.exports = __webpack_public_path__ + "static/media/footbal-3.d06e5ebc.jpg";